import { ErrorHandler, Injectable } from '@angular/core';
import { AppLogger } from './app-logger';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private logger: AppLogger) {}

  handleError(error: any): void {
    try {
      this.logger.error(error);
    } catch (loggerError) {
      console.error('Unable to log application error: ', loggerError);
      throw error;
    }
  }
}
